<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT"><b>ACKNOWLEDGMENTS</b></div>
<div class="fmtx1">Special thanks to Rich Leach, Matt Mariani, Steve Negen, Randy Gage, all the wonderful participants in the Marketing Mentor Program who let us share in the success of their stores, and most especially our children, Joe and Sam, who have been so patient and understanding while we worked on this book.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nege_9781118044704_oeb_ack_r1.vue?0381c41a